import type { ReactElement } from 'react';

export default function SidebarAddOnTag(): ReactElement {
  return (
    <span className="vtwo:flex vtwo:h-4 vtwo:shrink-0 vtwo:items-center vtwo:rounded vtwo:bg-[#c3e8d5] vtwo:px-1 vtwo:text-[10px] vtwo:font-medium vtwo:leading-none vtwo:text-black/50">
      Add-on
    </span>
  );
}
